import React from "react";
import { useLogin } from "./Hook";
import { Mobile } from "../../Utils/icons";
import "./style.scss";
import Btn from "../../Components/Btn";
import { p2e } from "../../Utils/functions";
const Login = () => {
  const { login, form, setForm, loading } = useLogin();
  return (
    <>
      <div className="input-mobile">
        <div className="icon-wrapper">
          <Mobile />
        </div>
        <input
          autoFocus={true}
          type="number"
          value={form.mobile}
          onChange={({ target: { value } }) => {
            if (value.length > 11) return;
            setForm({ ...form, mobile: p2e(value) });
          }}
          onKeyDown={e => {
            if (e.key == "Enter") {
              login();
            }
          }}
          placeholder="۰۹۱۲۰۰۰۰۰۰۰"
        />
      </div>
      <Btn text="ورود" onClick={login} loading={loading} />
    </>
  );
};

export default Login;
